// extracted by mini-css-extract-plugin
module.exports = {"modal":"OnboardingModal_modal__N0y2z","container":"OnboardingModal_container__2uUFN"};